module.exports = __webpack_public_path__ + "static/media/photo-1551354099-53143ba45404.438acfe2.jfif";